import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"padding":"0 10%"}
}
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Очистка данных планирования")
], -1)
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "Cleanup-settings" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, " Очистить ")
], -1)
const _hoisted_11 = { id: "Cleanup-info" }
const _hoisted_12 = {
  key: 0,
  class: "Cleanup-infoMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_CleanupInfoDialog = _resolveComponent("CleanupInfoDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DxButton, {
            class: "float-end",
            width: 36,
            type: "normal",
            icon: "info",
            hint: "Справка",
            "styling-mode": "contained",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowInfo()))
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DxSelectBox, {
              class: "ModelField-control",
              stylingMode: "outlined",
              "data-source": _ctx.modesStore,
              "show-clear-button": false,
              value: _ctx.modes[0].id,
              "display-expr": "caption",
              "value-expr": "id",
              onValueChanged: _ctx.onModeChange
            }, null, 8, ["data-source", "value", "onValueChanged"]),
            (_ctx.isShowDate)
              ? (_openBlock(), _createBlock(_component_DateControl, {
                  key: 0,
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  value: _ctx.date,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                  mode: "date"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DxButton, {
              "styling-mode": "outlined",
              class: "Cleanup-clean",
              type: "default",
              onClick: _ctx.onClean
            }, {
              content: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.showMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Очистка данных завершена "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DxLoadPanel, {
      class: "Cleanup-loading-panel",
      style: {"z-index":"9999"},
      position: _ctx.loadingPanelPosition,
      visible: _ctx.cleaning,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cleaning) = $event)),
      "show-indicator": true,
      "show-pane": false,
      shading: false,
      "close-on-outside-click": false,
      message: "Пожалуйста подождите. Идет очистка данных."
    }, null, 8, ["position", "visible"]),
    _createVNode(_component_CleanupInfoDialog, { ref: "infoDialog" }, null, 512)
  ]))
}